module.exports = __webpack_public_path__ + "img/18.208c7998.png";